import { MenuItem, Stack, TextField } from '@mui/material';
import { ICaseDetailsInputs } from 'API';
import { ControllerSelect, CustomRadioGroup } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { generateError } from 'Regex';
import { styleTextField } from 'Theme';
import { validateNumbersOnly } from 'Utils/validateNumbersOnly';

export const WAS_DRIVER_DURING_ACCIDENT_ID = 1;

export const WhatDidDoDuringAccident = () => {
  const { index } = useContext(IndexContext);
  const {
    register,
    formState: { errors },
  } = useFormContext<ICaseDetailsInputs>();

  const [AccidentOptions, ownershipVehicleTypes] = useAppSelector(
    ({
      generalContent: {
        generalContent: {
          whatHaveYouDoDuringAccidentOptions,
          ownershipVehicleTypes,
        },
      },
    }) => [whatHaveYouDoDuringAccidentOptions, ownershipVehicleTypes]
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}.trafficAccidentSection`;

  const whatHaveYouDoDuringAccidentOptionId = useWatch({
    name: `${baseName}.whatHaveYouDoDuringAccidentOptionId`,
  });

  const trafficAccidentError = errors.caseDetails
    ? errors.caseDetails[index]?.trafficAccidentSection?.vehicleDetailsSection
    : undefined;

  return (
    <>
      <CustomRadioGroup
        id={dictionary.thirdSectionWhatDidDoQ}
        name={`${baseName}.whatHaveYouDoDuringAccidentOptionId` as const}
        options={AccidentOptions.map(({ id, value }) => ({
          value: id.toString(),
          label: value,
        }))}
      />
      {whatHaveYouDoDuringAccidentOptionId == WAS_DRIVER_DURING_ACCIDENT_ID && (
        <Stack gap='20px'>
          <ControllerSelect
            name={
              `${baseName}.vehicleDetailsSection.ownershipVehicleId` as const
            }
            label={dictionary.thirdSectionFirstInputValue}
          >
            {ownershipVehicleTypes.map(({ value, id }) => (
              <MenuItem key={id} value={id}>
                {value}
              </MenuItem>
            ))}
          </ControllerSelect>
          <TextField
            inputProps={{
              maxLength: '8',
            }}
            id={`${dictionary.thirdSectionSecondInputValue}-${index}`}
            {...register(
              `${baseName}.vehicleDetailsSection.vehicleId` as `caseDetails.0.trafficAccidentSection.vehicleDetailsSection.vehicleId`
            )}
            label={dictionary.thirdSectionSecondInputValue}
            onKeyDown={(event) => validateNumbersOnly(event)}
            role={
              Boolean(trafficAccidentError?.vehicleId) ? 'alert' : undefined
            }
            error={Boolean(trafficAccidentError?.vehicleId)}
            helperText={
              Boolean(trafficAccidentError?.vehicleId?.message) &&
              generateError(
                dictionary.thirdSectionSecondInputValue,
                trafficAccidentError?.vehicleId?.message!
              )
            }
            sx={styleTextField}
          />
        </Stack>
      )}
    </>
  );
};
